export default __webpack_public_path__ + "static/media/Weka_taarifa.aca00a13.svg";